import { render, staticRenderFns } from "./NavigationDesktop.vue?vue&type=template&id=31003863&"
import script from "./NavigationDesktop.vue?vue&type=script&lang=js&"
export * from "./NavigationDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports